import React from 'react';
import './HoroscopesTile.scss';
import { HoroscopesIcon } from '../HoroscopesIcon/HoroscopesIcon';
import { HoroscopeIconType } from '../HoroscopesIcon/HoroscopesIcon-Constants';
import { useTranslation } from 'react-i18next';

interface HoroscopesTileProps {
  sign: HoroscopeIconType;
  onClick?: () => void;
}

export const HoroscopesTile: React.FC<HoroscopesTileProps> = ({
  sign,
  onClick,
}) => {
  const { t, i18n } = useTranslation();
  // Convert the sign enum value to a proper display name
  const getDisplayName = (signType: HoroscopeIconType): string => {
    return signType.charAt(0).toUpperCase() + signType.slice(1);
  };

  return (
    <div
      className="horoscopes-tile"
      onClick={onClick}
      data-testid="horoscopes-tile"
    >
      <div className="horoscopes-tile__icon">
        <HoroscopesIcon type={sign} width={94} height={120} />
      </div>
      <div className="horoscopes-tile__name body-sm">
        {getDisplayName(t(sign.toString()), sign.toString())}
      </div>
    </div>
  );
};
